import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toaster Component - Global toast notification container
 *
 * Configured to work with our custom Banner component for visual consistency.
 * Toasts are rendered using the BannerToast wrapper, which ensures all
 * notifications match our Ramps design system.
 *
 * @see BannerToast for the custom toast renderer
 * @see toast utilities in @/lib/toast for usage examples
 */
const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			className="toaster group"
			position="bottom-center"
			expand={false}
			closeButton={false} // Banner component has its own close button
			richColors={false} // Using custom Banner variants instead
			toastOptions={{
				unstyled: true, // Important: We're using Banner's styles
				classNames: {
					toast: "w-full max-w-2xl", // Max width for toasts
				},
			}}
			{...props}
		/>
	);
};

export { Toaster };
